import { render } from "./FluidHeightTableWithFixedHeaderAndColumns.vue?vue&type=template&id=1327c8ea"
import script from "./FluidHeightTableWithFixedHeaderAndColumns.vue?vue&type=script&lang=js"
export * from "./FluidHeightTableWithFixedHeaderAndColumns.vue?vue&type=script&lang=js"
script.render = render

export default script